import ServerDataGrid from "../../../components/datagrid/ServerDataGrid";
import { columns } from "./damageResolvedColumns";

export function DamageResolvedTablePage() {
  return (
    <ServerDataGrid
      columns={columns}
      getRowId={(row) => row.damage.id}
      apiEndpoint="/datagrid/damage-resolved"
      tableName="damage"
      enableCreate={false}
      enableSearch={true}
      height={"calc(100vh - 52.6px)"}
      initialStateOverride={{
        sorting: {
          sortModel: [{ field: "damage.date_resolved", sort: "desc" }],
        },
      }}
    />
  );
}
